import { render, staticRenderFns } from "./VideoSensibilizacion.vue?vue&type=template&id=768d5058&"
import script from "./VideoSensibilizacion.vue?vue&type=script&lang=js&"
export * from "./VideoSensibilizacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports